import { STOCK_DOCUMENT_STATUS } from "../../../../common/types/inventory"
import { INVENTORY_STOCK_DIRECTION } from "../../../../utils/inventory"
import { ACTION_TYPES, Actions } from "../actions/types"
import { stateHandler } from "./handler"
import { InitialState } from "./types"

export const INITIAL_STATE: InitialState = {
    // @ts-ignore
    contact: {},
    contactId: "",
    // @ts-ignore
    definition: {
        id: "",
        attributes: {
            name: "",
            prefix: "",
            direction: INVENTORY_STOCK_DIRECTION.IN_OUT,
            includeContact: false,
            colorCode: "",
            statuses: [],
            emailTemplates: [],
            documentTemplates: [],
        }
    },
    definitionId: "",
    // @ts-ignore
    inventoryLocation: {},
    // @ts-ignore
    project: {},
    // @ts-ignore
    seller: {},
    status: {
        id: "",
        attributes: {
            state: STOCK_DOCUMENT_STATUS.DRAFT,
            name: "",
            colorCode: "",
        },
        type: "status",
    },
    // @ts-ignore
    table: {},
    proposalHash: "",
    identifier: "",
    inventoryLocationId: "",
    accountId: "",
    id: "",

    isLoaded: false
}

export const reducer = (state = INITIAL_STATE, action: Actions) => {
    const handler = stateHandler(state)
    switch (action.type) {
    case ACTION_TYPES.ADJUST_INVENTORY:
        return handler.adjustInventory()
    case ACTION_TYPES.FETCH_SUCCESS:
        return handler.fetchSuccess(action.payload)
    case ACTION_TYPES.CLEAR:
        return handler.clear()
    case ACTION_TYPES.MARK_AS_DONE:
        return handler.markAsDone()
    default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/stockdocument/reducers/reducer.ts